import React from "react";
import { connect } from "react-redux";
import messages from "../../assets/i18n";
import PropTypes from "prop-types";
import Form from 'react-bootstrap/Form';
import { Row, Container } from "react-bootstrap";
import "./TagMarker.scss";

function TagMarker(props) {

    const { lang, onClick, enableDownload, enablePrint, enablePdf } = props;

    const handleChecked = (event) => {
        onClick(event.target.value);
    }

    return (
        <Form className="justify-content-center" >
            <Container className="py-1">
                <Row className="justify-content-center">
                    <p className="text-3 text-color-black font-weight-bolder my-0 pt-1">
                        {messages[lang.name].outFormat}
                    </p>
                </Row>
            </Container>
            <Container className="py-2 px-2 justify-content-between">
                {enableDownload &&
                <div className="md-radio md-radio-inline px-3">
                    <input
                        id="1"
                        type="radio"
                        name="outputFormat"
                        defaultChecked="true"
                        value="0"
                        onChange={handleChecked}
                    />
                    <label className="text-2" htmlFor="1">{messages[lang.name].download}</label>
                </div>
                }
                {enablePrint &&
                    <div className="md-radio md-radio-inline px-3">
                        <input
                            id="2"
                            type="radio"
                            name="outputFormat"
                            value="1"
                            onChange={handleChecked}
                        />
                        <label className="text-2" htmlFor="2">{messages[lang.name].print}</label>
                    </div>
                }
                {enablePdf &&
                    <div className="md-radio md-radio-inline px-3">
                        <input
                            id="3"
                            type="radio"
                            name="outputFormat"
                            value={2}
                            onChange={handleChecked}
                        />
                        <label className="text-2" htmlFor="3">{messages[lang.name].generatePDF}</label>
                    </div>
                }
            </Container>
        </Form>
    )
}


const mapStateToProps = state => {
    return {
        lang: state.language,
    }

};

TagMarker.propTypes = {
    onClick: PropTypes.func.isRequired,
    enableDownload: PropTypes.bool,
    enablePrint: PropTypes.bool,
    enablePdf: PropTypes.bool,
};

export default connect(
    mapStateToProps
)(TagMarker);

